export class LastValidated {
    date?: Date;
    dayDuration?: number;

    constructor(date?: Date, dayDuration?: number) {
        this.date = date;
        this.dayDuration = dayDuration;
    }
}
